import { useCurrencyAmountFormatter } from '@routable/shared';
import React from 'react';
import { CurrencyCode } from 'constants/currency';
const CurrencyAmount = ({ children = 0, className, formatOptions = {} }) => {
    const { formatCurrencyAmount } = useCurrencyAmountFormatter();
    const formattedAmount = formatCurrencyAmount({
        amount: children,
        currency: formatOptions.currencyCode ?? CurrencyCode.USD,
        precision: formatOptions.precision,
        style: 'accounting',
    });
    return (React.createElement("span", { className: className, "data-fullstory": true }, formattedAmount));
};
export default CurrencyAmount;
